import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

export enum IDAssume {
  Padre = '1',
  Madre = '2',
  Entrambi = '3',
  Altro = '4',
}

const assumeList = Object.freeze([
  {
    id: IDAssume.Padre,
    value: 'Cognome del padre',
  },
  {
    id: IDAssume.Madre,
    value: 'Cognome della madre',
  },
  {
    id: IDAssume.Entrambi,
    value: 'Entrambi i cognomi',
  },
  {
    id: IDAssume.Altro,
    value: 'Altro',
  },
]);

interface AssumeListProps {
  disabled?: boolean;
  error?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
}

const AssumeListComponent = ({
  disabled,
  onChange,
  required,
  value,
  error,
}: AssumeListProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="assume-list-label">
        {required ? 'Assume il cognome di *' : 'Assume il cognome di'}
      </InputLabel>
      <PmiSelect
        labelId="assume-list-label"
        id="assume-list"
        name="assume-list"
        value={value}
        label={required ? 'Assume il cognome di *' : 'Assume il cognome di'}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {assumeList.map((assume: ItemVM) => (
          <MenuItem key={assume.id} value={assume.id}>
            {assume.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

AssumeListComponent.displayName = 'List assume list component';

const AssumeList = memo(AssumeListComponent);

export default AssumeList as typeof AssumeListComponent;
